export default "__VITE_ASSET__2d259796__"